const DAY = 86400000;
const memory = new Map();
const startedAt = Date.now();
export function observeRadioCue(signal, account, { suppressed = false, enabled = true, now = Date.now() } = {}) {
  const key = signal?.announcement?.eventKey;
  const at = +new Date(signal?.announcement?.at || '');
  if (!key || !account || !Number.isFinite(at)) return false;
  const storageKey = `jg:radio:cue:v1:${account}`;
  let snapshot = memory.get(storageKey);
  if (!snapshot) {
    try { snapshot = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); } catch (_) { snapshot = {}; }
  }
  let seen = Array.isArray(snapshot) ? snapshot : snapshot?.events;
  const through = Number.isFinite(snapshot?.through) ? snapshot.through : startedAt - 1;
  seen = (Array.isArray(seen) ? seen : []).filter(r => typeof r?.key === 'string' && Number.isFinite(r.at) && now - r.at < 7 * DAY).slice(-63);
  // A monotonic watermark prevents an evicted older event from replaying.
  // Late/out-of-order events are deliberately dropped, never queued as a backlog.
  const already = at <= through || seen.some(r => r.key === key);
  if (!already) seen.push({ key, at: now });
  snapshot = { events: seen, through: at <= now ? Math.max(through, at) : through };
  memory.set(storageKey, snapshot);
  if (memory.size > 8) memory.delete(memory.keys().next().value);
  let storageAvailable = true;
  try { sessionStorage.setItem(storageKey, JSON.stringify(snapshot)); } catch (_) { storageAvailable = false; }
  return enabled && storageAvailable && !already && !suppressed && at >= startedAt && at <= now;
}
export function radioCueSuppressed({ playing, participationOpen, pathname }) {
  const active = document.activeElement;
  return Boolean(playing || participationOpen || document.hidden || /checkout|\/hitlab\/submit/.test(pathname) ||
    document.querySelector('[data-radio-payment-active="true"]') ||
    active?.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(active?.tagName));
}
